import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function AlertasDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Resumo");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("Nm_Visu_Perf").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      console.log(distributors);
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  function numerosMeses() {
    const nomesDosMeses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    const hoje = new Date();
    const mesAtualIndex = hoje.getMonth();
    let mesSeguinteIndex = hoje.getMonth() + 1;
    mesSeguinteIndex = mesSeguinteIndex === 12 ? 0 : mesSeguinteIndex;
    let mesAnteriorIndex = hoje.getMonth() - 1;
    mesAnteriorIndex = mesAnteriorIndex === -1 ? 11 : mesAnteriorIndex;
    return {
      mesAtual: nomesDosMeses[mesAtualIndex],
      mesAnterior: nomesDosMeses[mesAnteriorIndex],
      mesSeguinte: nomesDosMeses[mesSeguinteIndex],
    };
  }
  const meses = numerosMeses();

  return (
    <div className="app excelente">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Resumo"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Resumo"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Resumo"
            />

            <FormControlLabel
              value="Gatilho"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gatilho"
            />

            <FormControlLabel
              value="Sell out C9 Main Priorities"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Sell out C9 Main Priorities"
            />

            <FormControlLabel
              value="Distribuição"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Distribuição"
            />

            <FormControlLabel
              value="Market Share"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Market Share"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              <div className="adm-cards">
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gatilho",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                    justifyContent: "space-around",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="eb1f0bc9-d7d0-4995-8839-31fc68286be2"
                    reference={{ id: "eb1f0bc9-d7d0-4995-8839-31fc68286be2" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Sell Out",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="e1ab9478-1764-4b1e-bc84-6c43f81b6ffa"
                    reference={{ id: "e1ab9478-1764-4b1e-bc84-6c43f81b6ffa" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Distribuição",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="4a57eb09-932f-434f-bbbe-b226ed51f9aa"
                    reference={{ id: "4a57eb09-932f-434f-bbbe-b226ed51f9aa" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Market Share",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="d04c7957-4935-4f7a-98ee-7a0fa13dde5b"
                    reference={{ id: "d04c7957-4935-4f7a-98ee-7a0fa13dde5b" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "KPIs Performance",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="96ed0fb3-e004-4016-9f56-1127b2909ca0"
                    reference={{ id: "96ed0fb3-e004-4016-9f56-1127b2909ca0" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "% Atingimento",
                  }}
                  style={{
                    width: "20%",
                    height: "100%",
                  }}
                >
                  <NativeObject
                    app={app}
                    key="BTS"
                    reference={{ id: "BTS" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              </div>

              <>
                <div style={{ height: "55%" }}>
                  <Card
                    app={app}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="pmfefP"
                  >
                    <NativeObject
                      app={app}
                      key="pmfefP"
                      reference={{ id: "pmfefP" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>
                </div>
              </>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

AlertasDesktop.defaultProps = {
  app: null,
  config: {},
};

AlertasDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default AlertasDesktop;
